/* Carpatin Adventure Camp · Homepage 2026 · Website by MS web */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    const els = root.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
  }

  function initCallbar(root) {
    const bar = root.querySelector('.cac-callbar');
    const hero = root.querySelector('[data-callbar-trigger]') || root.querySelector('.cac-hero');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(([e]) => bar.classList.toggle('is-visible', !e.isIntersecting), { threshold: 0.15 });
    io.observe(hero);
  }

  function initRail(section) {
    const rail = section.querySelector('.cac-rail');
    if (!rail || rail.dataset.ready) return;
    rail.dataset.ready = '1';
    const prev = section.querySelector('[data-rail-prev]');
    const next = section.querySelector('[data-rail-next]');
    const bar = section.querySelector('.cac-progress span');
    const step = () => {
      const card = rail.querySelector('.cac-act');
      return card ? card.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
    };
    const update = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      const p = max > 0 ? rail.scrollLeft / max : 1;
      const visible = max > 0 ? rail.clientWidth / rail.scrollWidth : 1;
      if (bar) bar.style.setProperty('--p', Math.min(100, (visible + p * (1 - visible)) * 100) + '%');
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max - 2;
    };
    prev && prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }));
    next && next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }));
    rail.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();

    // Mouse drag on desktop (touch uses native swipe)
    let down = false, startX = 0, startLeft = 0, moved = false;
    rail.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; startX = e.clientX; startLeft = rail.scrollLeft;
    });
    window.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 4) { moved = true; rail.classList.add('is-dragging'); }
      rail.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', () => {
      if (!down) return;
      down = false;
      rail.classList.remove('is-dragging');
    });
    rail.addEventListener('click', (e) => { if (moved) { e.preventDefault(); moved = false; } }, true);
  }

  function initNight(section) {
    const media = section.querySelector('.cac-night__media');
    if (!media || reduce || !window.matchMedia('(hover: hover)').matches) return;
    media.addEventListener('pointermove', (e) => {
      const r = media.getBoundingClientRect();
      media.style.setProperty('--mx', ((e.clientX - r.left) / r.width) * 100 + '%');
      media.style.setProperty('--my', ((e.clientY - r.top) / r.height) * 100 + '%');
    });
  }

  const ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  const ICON_PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>';
  const ICON_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';

  function initLightbox(section) {
    const items = [...section.querySelectorAll('[data-lightbox]')];
    if (!items.length || section.dataset.lbReady) return;
    section.dataset.lbReady = '1';
    let dlg = document.querySelector('dialog.cac-lightbox');
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.className = 'cac-lightbox';
      dlg.setAttribute('aria-label', 'Galerie foto');
      dlg.innerHTML = '<div class="cac-lightbox__inner"><img alt=""></div>' +
        '<button type="button" class="cac-lightbox__btn cac-lightbox__close" aria-label="Închide">' + ICON_CLOSE + '</button>' +
        '<button type="button" class="cac-lightbox__btn cac-lightbox__prev" aria-label="Imaginea anterioară">' + ICON_PREV + '</button>' +
        '<button type="button" class="cac-lightbox__btn cac-lightbox__next" aria-label="Imaginea următoare">' + ICON_NEXT + '</button>';
      document.body.appendChild(dlg);
      dlg.addEventListener('click', (e) => { if (e.target === dlg || e.target.classList.contains('cac-lightbox__inner')) dlg.close(); });
      dlg.querySelector('.cac-lightbox__close').addEventListener('click', () => dlg.close());
    }
    const img = dlg.querySelector('img');
    let list = items, idx = 0;
    const show = (i) => {
      idx = (i + list.length) % list.length;
      img.src = list[idx].dataset.lightbox;
      img.alt = list[idx].querySelector('img')?.alt || '';
    };
    dlg.querySelector('.cac-lightbox__prev').onclick = () => show(idx - 1);
    dlg.querySelector('.cac-lightbox__next').onclick = () => show(idx + 1);
    dlg.onkeydown = (e) => { if (e.key === 'ArrowLeft') show(idx - 1); if (e.key === 'ArrowRight') show(idx + 1); };
    items.forEach((btn, i) => btn.addEventListener('click', () => {
      list = items;
      show(i);
      if (typeof dlg.showModal === 'function') dlg.showModal();
    }));
  }

  function init(root = document) {
    initReveal(root);
    initCallbar(document);
    root.querySelectorAll('.cac-acts').forEach(initRail);
    root.querySelectorAll('.cac-night').forEach(initNight);
    root.querySelectorAll('.cac-gal').forEach(initLightbox);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
